module.exports = __webpack_public_path__ + "static/Screen_inside_mob_01_on_landing-4adc13b270092458e7952885a840f527.png";